import { render } from "./ContactImage.vue?vue&type=template&id=6b1a3680"
import script from "./ContactImage.vue?vue&type=script&lang=js"
export * from "./ContactImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__